import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';
import AuthFlowLayout from 'src/layouts/AuthFlow/AuthFlowLayout';
import { translateKey } from 'src/locales/translate';
import { PATH_AUTH } from 'src/routes/paths';
import AuthNewPasswordForm from './AuthNewPasswordForm';

export default function AuthNewPassword(): ReactElement {
  return (
    <AuthFlowLayout screen="newPassword">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {translateKey('hardcoded.stworz_nowe_haslo_aby_w_pelni_korzystac_z')}
      </Typography>
      <AuthNewPasswordForm />
      <Link
        component={RouterLink}
        to={PATH_AUTH.login}
        color="text.primary"
        variant="subtitle2"
        sx={{ alignItems: 'center', display: 'inline-flex', mt: 3 }}
      >
        <Iconify icon="eva:chevron-left-fill" width={16} />
        {translateKey('hardcoded.powrot_do_strony_logowania')}
      </Link>
    </AuthFlowLayout>
  );
}
